import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { AdminAuthProvider } from './contexts/AdminAuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminProtectedRoute from './components/AdminProtectedRoute';
import DashboardLayout from './layouts/DashboardLayout';
import Login from './pages/Login';
import SignupPage from './pages/SignupPage';
import GoogleOnboardingPage from './pages/GoogleOnboardingPage';
import PricingPage from './pages/PricingPage';
import DashboardPage from './pages/DashboardPage';
import Team from './pages/Team';
import Scheduler from './pages/Scheduler';
import Attendance from './pages/Attendance';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import ShiftTypes from './pages/settings/ShiftTypes';
import Notifications from './pages/settings/Notifications';
import DeactivationShifts from './pages/settings/DeactivationShifts';
import AdminLogin from './pages/admin/AdminLogin';
import AdminConsole from './pages/admin/AdminConsole';
import AdminRestaurantDetail from './pages/admin/AdminRestaurantDetail';

function App() {
  return (
    <AuthProvider>
      <AdminAuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/google-onboarding" element={<GoogleOnboardingPage />} />

          {/* Story 28 — obscure platform-admin route, own auth state, deliberately outside
              the tenant AuthProvider's ProtectedRoute tree. */}
          <Route path="/iseeallnomisses" element={<AdminLogin />} />
          <Route
            path="/iseeallnomisses/console"
            element={
              <AdminProtectedRoute>
                <AdminConsole />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/iseeallnomisses/restaurants/:id"
            element={
              <AdminProtectedRoute>
                <AdminRestaurantDetail />
              </AdminProtectedRoute>
            }
          />

          {/* Authenticated routes — wrapped in DashboardLayout */}
          <Route
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/team" element={<Team />} />
            <Route path="/scheduler" element={<Scheduler />} />
            <Route path="/attendance" element={<Attendance />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/settings/shift-types" element={<ShiftTypes />} />
            <Route path="/settings/notifications" element={<Notifications />} />
            <Route path="/settings/deactivation-shifts" element={<DeactivationShifts />} />
          </Route>

          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      </AdminAuthProvider>
    </AuthProvider>
  );
}

export default App;